function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { SingleDropdownTokenControl, Menu, useDropdown, Control } from '@adsk/alloy-react-dropdown';
import { noop } from '@adsk/alloy-react-helpers';
import Portal from '@adsk/alloy-react-portal';
import { defaultValueTagRenderer, defaultFooterRenderer, defaultMenuItemRenderer, defaultVirtualizedItemsRenderer, getMenuStyle, renderWrapper, getFilteredMenuItems } from '../helpers/utils';
import { useSelectedItem, useVirtualizedHelpers } from '../hooks';
const SingleAssigneePicker = _ref => {
  let {
    showIcons = false,
    showGroupCountInTags = false,
    showAvatars = false,
    showValueAsTags = true,
    dropdownProps = {},
    disabled = false,
    clearable = false,
    onChange = noop,
    isLoading,
    items,
    hiddenMenuItemsIdsSet,
    renderControl = props => showValueAsTags ? /*#__PURE__*/React.createElement(SingleDropdownTokenControl, props) : /*#__PURE__*/React.createElement(Control, props),
    renderMenu = props => /*#__PURE__*/React.createElement(Menu, props),
    renderVirtualizedMenuFooter = defaultFooterRenderer,
    renderMenuItem = defaultMenuItemRenderer,
    error,
    container
  } = _ref;
  const selectedItemProps = useSelectedItem(dropdownProps, items);
  const {
    controlProps,
    menuProps
  } = useDropdown(_objectSpread(_objectSpread(_objectSpread({
    onSelectedItemChange: changes => {
      onChange(changes.selectedItem || null);
    }
  }, dropdownProps), selectedItemProps), {}, {
    groupedItems: items
  }));
  const {
    isOpen,
    selectedItem,
    getItemProps,
    isGroupHeader,
    menuItems,
    selectItem
  } = menuProps;
  const filteredMenuItems = useMemo(() => getFilteredMenuItems({
    items: menuItems,
    idsToHide: hiddenMenuItemsIdsSet
  }), [menuItems, hiddenMenuItemsIdsSet]);
  const {
    parentRef,
    rowVirtualizer
  } = useVirtualizedHelpers({
    menuItems: filteredMenuItems,
    isGroupHeader,
    isOpen
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderControl(_objectSpread(_objectSpread({}, controlProps), {}, {
    error,
    itemToString: item => defaultValueTagRenderer(item, {
      showIcons,
      showGroupCountInTags
    }),
    isLoading,
    disabled
  })), /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, renderMenu(_objectSpread(_objectSpread({}, menuProps), {}, {
    rowVirtualizer,
    style: getMenuStyle({
      isOpen,
      isLoading
    }),
    renderWrapper: renderWrapper({
      parentRef,
      isOpen,
      setSelectedItems: () => selectItem(null),
      clearable,
      hasSelectedItems: !!selectedItem,
      renderVirtualizedMenuFooter,
      totalSize: rowVirtualizer.totalSize
    }),
    children: defaultVirtualizedItemsRenderer({
      rowVirtualizer,
      groupedMenuItems: filteredMenuItems,
      isGroupHeader,
      getItemProps,
      renderMenuItem,
      showAvatars
    })
  }))));
};
export default SingleAssigneePicker;
//# sourceMappingURL=SingleAssigneePicker.js.map